'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Alert } from '@shared/ui-components/alert/alert';
import { AlertVariant } from '@shared/ui-components/alert/alertVariant';
import { CheckboxInput } from '@shared/ui-components/checkbox-input/checkbox-input';
import { useWebPushStatus } from '../../utils/helpers/use-web-push-status';
import { useNotificationPermissionDenied } from '../../utils/hooks/use-notification-permission-denied';
import { type PushNotificationsPrePromptModalCmsContent } from '../push-notifications-pre-prompt-modal/push-notifications-pre-prompt-modal';
import { PushNotificationsPrePromptModalLoader } from '../push-notifications-pre-prompt-modal/push-notifications-pre-prompt-modal-loader';
import styles from './notification-preference-toggle.module.scss';
type NotificationPreferenceToggleProps = {
  description?: string;
  hintLabel?: string;
  id: string;
  modalCmsContent: PushNotificationsPrePromptModalCmsContent;
  title: string;
};
export const PushNotificationPreferenceToggle = t0 => {
  const $ = _c(29);
  const {
    description,
    hintLabel,
    id,
    modalCmsContent,
    title
  } = t0;
  const {
    handlePrePromptAllow,
    handlePrePromptClose,
    handlePushToggle,
    isPrePromptLoading,
    isPrePromptModalOpen,
    isToggleChecked,
    isToggleDisabled,
    isToggleLoading
  } = useWebPushStatus();
  const isPushPermissionDenied = useNotificationPermissionDenied(true);
  let t1;
  if ($[0] !== title) {
    t1 = <h4 className={styles["notification-preference-toggle__title"]}>{title}</h4>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handlePushToggle || $[3] !== id || $[4] !== isToggleChecked || $[5] !== isToggleDisabled || $[6] !== isToggleLoading) {
    t2 = <CheckboxInput disabled={isToggleDisabled} id={id} isChecked={isToggleChecked} isLoading={isToggleLoading} isSwitch={true} label="" onChange={handlePushToggle} pushToRight={true} />;
    $[2] = handlePushToggle;
    $[3] = id;
    $[4] = isToggleChecked;
    $[5] = isToggleDisabled;
    $[6] = isToggleLoading;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className={styles["notification-preference-toggle__header"]}>{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== hintLabel || $[12] !== isPushPermissionDenied) {
    t4 = isPushPermissionDenied && hintLabel && <Alert className={styles["notification-preference-toggle__alert"]} message={hintLabel} variant={AlertVariant.Error} />;
    $[11] = hintLabel;
    $[12] = isPushPermissionDenied;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== description) {
    t5 = description && <p className={classNames(styles["notification-preference-toggle__content"])}>{description}</p>;
    $[14] = description;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className={styles["notification-preference-toggle"]}>{t3}{t4}{t5}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== handlePrePromptAllow || $[21] !== handlePrePromptClose || $[22] !== isPrePromptLoading || $[23] !== isPrePromptModalOpen || $[24] !== modalCmsContent) {
    t7 = <PushNotificationsPrePromptModalLoader cmsContent={modalCmsContent} isLoading={isPrePromptLoading} isOpen={isPrePromptModalOpen} onAllow={handlePrePromptAllow} onClose={handlePrePromptClose} />;
    $[20] = handlePrePromptAllow;
    $[21] = handlePrePromptClose;
    $[22] = isPrePromptLoading;
    $[23] = isPrePromptModalOpen;
    $[24] = modalCmsContent;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t6 || $[27] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};